import { useStaticQuery, graphql } from 'gatsby'
import { getImage, getSrc } from 'gatsby-plugin-image'
import {
  CRM_ACCOUNT_LOGO,
  CRM_ACCOUNT_NAME,
  CRM_LISTING_ID,
} from '../data/crmAccount'

export function useCrmListingAccount() {
  const data = useStaticQuery(graphql`
    query CrmListingAccount {
      listing: allMdx(
        limit: 1
        filter: {
          fields: { sourceName: { eq: "listings" } }
          frontmatter: { id: { eq: "z-pet-hotels" } }
        }
      ) {
        nodes {
          frontmatter {
            postTitle
            icon {
              childImageSharp {
                gatsbyImageData(width: 128, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  `)

  const frontmatter = data.listing?.nodes?.[0]?.frontmatter
  const name =
    frontmatter?.postTitle?.trim() || CRM_ACCOUNT_NAME
  const icon = frontmatter?.icon
  const logoSrc = icon
    ? getSrc(getImage(icon))
    : CRM_ACCOUNT_LOGO

  return {
    listingId: CRM_LISTING_ID,
    name,
    logoSrc,
  }
}
